import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Paragraph, Text } from 'components/core/Typography';
import { UnitIcon } from 'components/unit/UnitIcon';

import './unitSizeGuide.scss';

/* eslint-disable max-len */
// NOTE: the `sqft` prop on the items are part of the experiment
const UNIT_SIZES = [
	{
		display: '5\' x 5\'',
		bucket: '5x5',
		squareFootage: 25,
		looksLike: 'A small closet',
		goodFor: "The contents of one large closet. This size is ideal for seasonal decorations, personal items, gardening equipment, camping gear, children's toys, or off-season clothing."
	}, {
		display: '5\' x 10\'',
		bucket: '5x10',
		squareFootage: 50,
		looksLike: 'A walk-in closet',
		goodFor: 'The contents of one bedroom or dorm room, such as a mattress set, couch, table, chairs, and boxes.'
	}, {
		display: '5\' x 15\'',
		bucket: '5x15',
		squareFootage: 75,
		looksLike: 'A large walk-in closet',
		goodFor: 'The contents of two rooms, such as large dining sets, desks, cabinets, mattress sets, and washer/dryer. '
	}, {
		display: '10\' x 10\'',
		bucket: '10x10',
		squareFootage: 100,
		looksLike: 'A small bedroom',
		goodFor: 'The contents of one large bedroom, such as bedroom/living sets, refrigerator, large drawers, shelves, and multiple boxes.'
	}, {
		display: '10\' x 15\'',
		bucket: '10x15',
		squareFootage: 150,
		looksLike: 'A small one-car garage',
		goodFor: 'The contents of three to four rooms, such as multiple bedroom sets, large appliances and patio sets. May also fit smaller cars, boats, and other small vehicles.'
	}, {
		display: '10\' x 20\'',
		bucket: '10x20',
		squareFootage: 200,
		looksLike: 'A standard one-car garage',
		goodFor: 'The contents of a two to three-bedroom house, such as multiple bedroom sets, and large furniture. Can also fit trucks, trailers, and other mid-size vehicles.'
	}, {
		display: '10\' x 30\'',
		bucket: '10x30',
		squareFootage: 300,
		looksLike: 'A large car garage. Often the largest unit size at most facilities.',
		goodFor: 'The contents of a four- to six-bedroom house, such as mattress sets, large furniture, major appliances, seasonal items, outdoor equipment, and bikes. Will fit most vehicles.'
	}
];

export default function UnitSizeGuide({ className }) {
	return (
		<div className={classnames(className, 'unit-size-guide')}>
			<div className="unit-sizes">
				{UNIT_SIZES.map((unit) => (
					<div
						className="unit-size"
						key={unit.squareFootage}
					>
						<div className="unit-icon-container">
							<UnitIcon unitSize={`${unit.bucket}-storage`} />
						</div>
						<div>
							<Paragraph size="medium">
								{unit.display}
							</Paragraph>
							<Paragraph>
								<Text size="small">This unit is:</Text> {unit.squareFootage} sqft
							</Paragraph>
							<Paragraph>
								<Text size="small">Looks like:</Text> {unit.looksLike}
							</Paragraph>
							<Paragraph last>
								<Text size="small">What will fit:</Text> {unit.goodFor}
							</Paragraph>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

UnitSizeGuide.propTypes = {
	className: PropTypes.string
};
